<template>
  <div class="container">
    <div class="row">
      <div class="col-md-4">
        <div class="form-group required">
          <label for="cpf_cnpj">CPF/CNPJ do proprietário (origem) </label>
          <input
            type="tel"
            class="form-control"
            v-mask="['###.###.###-##', '##.###.###/####-##']"
            name="cpf_cnpj"
            id="cpf_cnpj"
            @blur="onCpfCnpjBlur"
            v-model="bloco.cpf_cnpj_produtor_origem"
            :readonly="bloco.cod_gtiv_bloco"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group required">
          <label for="nome_produtor_origem">Nome do proprietário</label>
          <input
            type="text"
            class="form-control"
            name="nome_produtor_origem"
            id="nome_produtor_origem"
            v-model="bloco.nome_produtor_origem"
            :readonly="is_produtor_sidagro || bloco.cod_gtiv_bloco"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="inscricao_estadual_origem">Inscrição Estadual</label>
          <input
            type="text"
            class="form-control"
            name="inscricao_estadual_origem"
            id="inscricao_estadual_origem"
            v-model="bloco.inscricao_estadual_origem"
            :readonly="bloco.tipo_produtor === 'F'"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group required">
          <label>Propriedade</label>
          <select
            class="form-control"
            v-model="bloco.cod_propriedade"
            @change="onChangePropriedade"
            :readonly="bloco.cod_gtiv_bloco"
          >
            <option value>Selecione</option>
            <option
              v-for="(propriedade, index) in propriedades"
              :key="index"
              :value="propriedade.codpropriedade"
            >
              {{
                `${propriedade.codpropriedade} - ${propriedade.nomepropriedade}`
              }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group required">
          <label for="endereco_origem">Endereço</label>
          <input
            type="text"
            class="form-control"
            name="endereco_origem"
            id="endereco_origem"
            v-model="bloco.endereco_origem"
            :readonly="selected_propriedade || bloco.cod_gtiv_bloco"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group required">
          <label for="municipio_origem">Município</label>
          <input
            type="text"
            class="form-control"
            name="municipio_origem"
            id="municipio_origem"
            v-model="bloco.municipio_origem"
            :readonly="selected_propriedade || bloco.cod_gtiv_bloco"
          />
        </div>
      </div>
      <div class="col-md-1">
        <div class="form-group required">
          <label for="uf_origem">UF</label>
          <input
            type="text"
            class="form-control"
            name="uf_origem"
            id="uf_origem"
            v-model="bloco.uf_origem"
            :readonly="selected_propriedade || bloco.cod_gtiv_bloco"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-1">
        <div
          :class="{
            'form-group': true,
            required: !bloco.preenchimentoEletronico && !bloco.cod_gtiv_bloco,
          }"
        >
          <!--Alteração para ateder a retirada do bloco-->
          <!--<label for="qtd">Quantidade de GTIV</label>-->
          <!--          <label for="qtd"></label>-->

          <!-- <select
            name="qtd"
            id="qtd"
            v-model="bloco.qtd"
            :readonly="bloco.cod_gtiv_bloco || bloco.preenchimentoEletronico"
            class="form-control"
          >
            <option value="">Selecione</option>
            <option value="5">5</option>
            <option value="10">10</option>
          </select> -->
          <!--type= "numeric"-->
          <input
            min="1"
            max="15"
            type="hidden"
            name="qtd"
            id="qtd"
            v-model="bloco.qtd"
            :readonly="bloco.cod_gtiv_bloco || bloco.preenchimentoEletronico"
            class="form-control"
          />
          <span v-if="bloco.qtd > 5" style="color: red"
          >Quantidade máxima de 5 gtiv</span
          >
        </div>
      </div>
      <div class="col-md-4" v-if="bloco.link_boleto">
        <label>Status do boleto</label>
        <span class="text text-primary text-bold">{{
            bloco.boleto_pago == 1 ? "PAGO" : ""
          }}
        {{
            bloco.boleto_pago == 0 ? "PENDENTE" : ""
          }}
        </span>
        <br/>
        <a
          :href="bloco.link_boleto"
          v-if="bloco.boleto_pago == 0"
          target="_blank"
        ><i class="fa fa-file"></i> Baixar o boleto</a
        >
      </div>
      <!--Preenchimento eletrônico-->
      <!--      <div class="col-md-4" v-else>
              <label class="show-control-text" for="preenchimentoEletronico"
                >Confirmo emisão da GTIV?</label
              >
              <label class="switch">
                <input
                  type="checkbox"
                  id="preenchimentoEletronico"
                  v-model="bloco.preenchimentoEletronico"
                  @input="onChangePreenchimentoEletronico"
                />
                <span class="slider"></span>
              </label>
            </div>-->
    </div>
    <fieldset class="sida-fieldset" v-if="bloco.fichas.length">
      <legend>GTIV emitidas</legend>
      <div
        class="status-labels"
        v-if="
          bloco.preenchimentoEletronico !== true && bloco.is_manual_generated
        "
      >
        <!-- <label>Pendente</label>
        <label>Pendente de informações</label>
        <label>Prestado</label> -->
      </div>
      <accordion-component>
        <div v-for="(ficha, index) in bloco.fichas" :key="index">
          <h1 class="accordion-title">
            {{ ficha.identificacao }}

            <div
              class="div-status"
              v-if="
                bloco.preenchimentoEletronico !== true &&
                bloco.is_manual_generated
              "
            >
              <span :class="`badge badge-${ficha.cod_status}`">{{
                  getStatusName(ficha.cod_status)
                }}</span>
            </div>
          </h1>

          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-3">
                  <label class="text text-primary">Identificação</label>
                  <span class="text">{{ ficha.identificacao }}</span>
                </div>
                <div class="col-md-4" v-if="!bloco.preenchimentoEletronico">
                  <div class="form-group">
                    <label :for="'cod_status' + index">Status</label>
                    <select
                      name="cod_status"
                      :id="'cod_status' + index"
                      class="form-control"
                      v-model="ficha.cod_status"
                    >
                      <option
                        v-for="(item, key) in statuses"
                        :key="key"
                        :value="item.cod_status"
                      >
                        {{ item.nome_status }}
                      </option>
                      <!-- <option value="9">Pendente</option>
                      <option value="23">Prestado</option>
                      <option value="24">Pendente de informações</option>
                      <option value="22">Extraviado</option> -->
                    </select>
                  </div>
                </div>
                <div
                  class="col-md-3"
                  v-if="bloco.preenchimentoEletronico !== true"
                >
                  <div
                    :class="{ 'form-group': true, required: isRequired(ficha) }"
                  >
                    <label class="text text-primary">Validade</label>
                    <span class="text" v-if="ficha.validade">{{
                        moment(ficha.validade).format("DD/MM/YYYY")
                      }}</span>
                    <datepicker-component
                      v-else
                      v-model="ficha.validade_input"
                      input-class="form-control"
                    ></datepicker-component>
                  </div>
                </div>
                <div class="col-md-3" v-if="bloco.preenchimentoEletronico">
                  <div class="form-group required">
                    <label class="text text-primary">Data de saída</label>
                    <datepicker-component
                      v-model="ficha.data_saida"
                      input-class="form-control"
                      :disabledDates="{ to: new Date(Date.now() - 86400000) }"
                    ></datepicker-component>
                  </div>
                </div>
              </div>
              <hr class="my-2"/>
              <h2>Dados do produto</h2>
              <add-item-table-component
                v-model="ficha.produtos"
                id-field="cod_gtiv_ficha_produtos"
                name="gtiv_ficha_produtor"
                :required="isRequired(ficha)"
                @change="addProdutos($event, index)"
              >
                <div class="row d-flex align-items-end form-fields">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label :for="'produto' + index">Produto</label>
                      <select
                        name="produto"
                        :id="'produto' + index"
                        class="form-control"
                        v-model="selectedProduto"
                      >
                        <option value>Selecione</option>
                        <option
                          v-for="(cult, index) in culturasPermitidasPropriedade"
                          :key="index"
                          :value="cult.cd_cultura"
                        >
                          {{ cult.nm_cultura }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="d-none">
                    <div class="form-group">
                      <label :for="'variedade' + index">Variedade</label>
                      <input
                        type="tel"
                        class="form-control"
                        name="variedade"
                        :id="'variedade' + index"
                        v-model="variedade"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label :for="'qtd' + index">Quantidade</label>
                      <input
                        type="tel"
                        class="form-control"
                        name="qtd"
                        :id="'qtd' + index"
                        v-numeric
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label :for="'capacidade_reservatorio' + index"
                      >Unidade</label
                      >
                      <select
                        name="unidade"
                        :id="'unidade' + index"
                        class="form-control"
                      >
                        <option value>Selecione</option>
                        <option
                          v-for="(um, index) in unidadesDeMedida"
                          :key="index"
                          :value="um.cod_unidade_medida"
                        >
                          {{ um.descricao_unidade_medida }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label :for="'num_unidade_producao' + index"
                      >N° da unidade de produção</label
                      >
                      <select
                        name="num_unidade_producao"
                        :id="'num_unidade_producao' + index"
                        class="form-control"
                        v-model="variedade_cod"
                        @change="onChangeUnidadeProducao(variedade_cod)"
                      >
                        <option value="">Selecione</option>
                        <option
                          :value="up.cd_unidade_producao"
                          v-for="(up, index) in getUnidadesProducao"
                          :key="index"
                        >
                          {{ up.cd_unidade_producao }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </add-item-table-component>
              <hr class="my-2"/>
              <h2>Identificação do destino</h2>
              <div class="row">
                <div class="col-md-4">
                  <div :class="{ 'form-group': true }">
                    <label :for="'cpf_cnpj_destinatario' + index"
                    >CPF/CNPJ do destinatário</label
                    >
                    <input
                      type="tel"
                      class="form-control"
                      name="cpf_cnpj_destinatario"
                      :id="'cpf_cnpj_destinatario' + index"
                      v-model="ficha.cpf_cnpj_destinatario"
                      v-mask="['###.###.###-##', '##.###.###/####-##']"
                      @blur="onCpfCnpjDestinoBlur(ficha)"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div
                    :class="{ 'form-group': true, required: isRequired(ficha) }"
                  >
                    <label :for="'destinatario' + index"
                    >Nome do destinatário</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      name="destinatario"
                      :id="'destinatario' + index"
                      v-model="ficha.destinatario"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div
                    :class="{ 'form-group': true, required: isRequired(ficha) }"
                  >
                    <label :for="'endereco_destino' + index">Endereço</label>
                    <input
                      type="text"
                      class="form-control"
                      name="endereco_destino"
                      :id="'endereco_destino' + index"
                      v-model="ficha.endereco_destino"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div
                    :class="{ 'form-group': true, required: isRequired(ficha) }"
                  >
                    <label :for="'municipio' + index" style="margin-bottom: 5px"
                    >Município</label
                    >
                    <select-municipio-component
                      name="municipio"
                      v-model="ficha.municipioDestinoObj"
                      @input="onChangeMunicipioDestino(ficha)"
                      :just-ceara="true"
                    ></select-municipio-component>
                  </div>
                </div>
                <div class="col-md-4">
                  <div
                    :class="{ 'form-group': true, required: isRequired(ficha) }"
                  >
                    <label>UF</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="ficha.municipioDestinoObj.uf"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Inscrição estadual</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="ficha.inscricao_estadual_destino"
                    />
                  </div>
                </div>
              </div>
              <hr class="my-2"/>
              <h2>Identificação de transporte/condutor</h2>
              <div
                :class="{
                  'form-group': true,
                  'radio-group': true,
                  required: isRequired(ficha),
                }"
              >
                <label class="text text-primary">Tipo de transporte:</label>
                <div class="row">
                  <div class="col-md-2">
                    <label>
                      <input
                        type="radio"
                        :name="`tipo_transporte${index}`"
                        class="form-control"
                        v-model="ficha.tipo_transporte"
                        value="RODOVIÁRIO"
                      />
                      Rodoviário
                    </label>
                  </div>
                  <div class="col-md-2">
                    <label>
                      <input
                        type="radio"
                        :name="`tipo_transporte${index}`"
                        class="form-control"
                        v-model="ficha.tipo_transporte"
                        value="AEREO"
                      />
                      Aéreo
                    </label>
                  </div>
                  <div class="col-md-2">
                    <label>
                      <input
                        type="radio"
                        :name="`tipo_transporte${index}`"
                        class="form-control"
                        v-model="ficha.tipo_transporte"
                        value="HIDROVIARIO"
                      />
                      Hidroviário
                    </label>
                  </div>
                  <div class="col-md-2">
                    <label>
                      <input
                        type="radio"
                        :name="`tipo_transporte${index}`"
                        class="form-control"
                        v-model="ficha.tipo_transporte"
                        value="FERROVIARIO"
                      />
                      Ferroviário
                    </label>
                  </div>
                  <div class="col-md-3">
                    <label>
                      <input
                        type="radio"
                        :name="`tipo_transporte${index}`"
                        class="form-control"
                        v-model="ficha.tipo_transporte"
                        value="OUTRO"
                      />
                      Outro
                    </label>
                    <div
                      class="form-group"
                      v-show="ficha.tipo_transporte == 'OUTRO'"
                    >
                      <input
                        type="text"
                        class="form-control"
                        v-model="ficha.tipo_transporte_outro"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div :class="{ 'form-group': true }">
                    <label :for="'nome_condutor' + index"
                    >Nome do condutor</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      name="nome_condutor"
                      :id="'nome_condutor' + index"
                      v-model="ficha.nome_condutor"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div :class="{ 'form-group': true }">
                    <label :for="'num_habilitacao' + index"
                    >N° Habilitação</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      name="num_habilitacao"
                      :id="'num_habilitacao' + index"
                      v-model="ficha.num_habilitacao"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div :class="{ 'form-group': true }">
                    <label :for="'cpf_condutor' + index">CPF</label>
                    <input
                      type="text"
                      class="form-control"
                      name="cpf_condutor"
                      :id="'cpf_condutor' + index"
                      v-model="ficha.cpf_condutor"
                      v-mask="'###.###.###-##'"
                      data-validation="cpf"
                    />
                  </div>
                </div>
              </div>
              <h3>Identificação do veículo</h3>
              <div class="row">
                <div class="col-md-4">
                  <div
                    :class="{
                      'form-group': true,
                      required: ficha.tipo_transporte == 'RODOVIÁRIO',
                    }"
                  >
                    <label :for="'marca_modelo_veiculo' + index"
                    >Marca/Modelo</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      name="marca_modelo_veiculo"
                      :id="'marca_modelo_veiculo' + index"
                      v-model="ficha.marca_modelo_veiculo"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <label class="show-control-text" for="is_mercosul"
                  >Placa Mercosul?</label
                  >
                  <label class="switch">
                    <input
                      type="checkbox"
                      class="form-control"
                      id="is_mercosul"
                      v-model="ficha.is_mercosul"
                      @input="onChangeIs_mercosul(ficha)"
                    />
                    <span class="slider"></span>
                  </label>
                </div>
                <div class="col-md-2">
                  <div
                    :class="{
                      'form-group': true,
                      required: ficha.tipo_transporte == 'RODOVIÁRIO',
                    }"
                  >
                    <label :for="'placa_veiculo' + index">Placa</label>
                    <input
                      type="text"
                      class="form-control"
                      name="placa_veiculo"
                      :id="'placa_veiculo' + index"
                      v-model="ficha.placa_veiculo"
                      v-mask="selectFichaMask(ficha)"
                    />
                  </div>
                </div>
                <div class="col-md-4" v-if="ficha.is_mercosul">
                  <div
                    :class="{
                      'form-group': true,
                      required: ficha.tipo_transporte == 'RODOVIÁRIO',
                    }"
                  >
                    <label :for="'nacionalidade_veiculo' + index">País</label>
                    <select-nacionalidade-placa-component
                      name="nacionalidade_veiculo"
                      :id="'nacionalidade_veiculo' + index"
                      class="autocomplete"
                      v-model="ficha.nacionalidade_veiculoObj"
                      @input="onChangeNacionalidadeVeiculo(ficha)"
                      :isMercosul="true"
                    ></select-nacionalidade-placa-component>
                  </div>
                </div>
                <div class="col-md-4" v-else>
                  <div
                    :class="{
                      'form-group': true,
                      required: ficha.tipo_transporte == 'RODOVIÁRIO',
                    }"
                  >
                    <label :for="'municipio_veiculo' + index">Município</label>
                    <select-municipio-placa-component
                      name="municipio_veiculo"
                      :id="'municipio_veiculo' + index"
                      class="autocomplete"
                      v-model="ficha.municipio_veiculoObj"
                      @input="onChangeMunicipioVeiculo(ficha)"
                      :just-ceara="false"
                    ></select-municipio-placa-component>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div
                    :class="{ 'form-group': true, required: isRequired(ficha) }"
                  >
                    <label :for="'itinerario' + index">Itinerário</label>
                    <textarea
                      name="itinerario"
                      :id="'itinerario' + index"
                      class="form-control"
                      v-model="ficha.itinerario"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="row" v-if="bloco.preenchimentoEletronico !== true">
                <!-- <div class="col-md-4">
                  <div class="form-group">
                    <label :for="'cod_status' + index">Status</label>
                    <select
                      name="cod_status"
                      :id="'cod_status' + index"
                      class="form-control"
                      v-model="ficha.cod_status"
                    >
                      <option value="9">Pendente</option>
                      <option value="23">Prestado</option>
                      <option value="24">Pendente de informações</option>
                      <option value="22">Extraviado</option>
                    </select>
                  </div>
                </div> -->
                <div class="col-md-8">
                  <div
                    :class="{
                      'form-group': true,
                      required: [22, 26].includes(ficha.cod_status),
                    }"
                  >
                    <label :for="'anexo' + index">Anexo</label>
                    <input
                      type="file"
                      :name="`anexo[${ficha.cod_gtiv_ficha}]`"
                      :id="'anexo' + index"
                      class="form-control anexo-ficha-input-file"
                      accept="application/pdf, image/*"
                    />
                  </div>
                  <h4 class="text text-black text-bold">Arquivos enviados:</h4>
                  <ul>
                    <li
                      v-for="(anexo, indexAnexo) of ficha.anexos"
                      :key="indexAnexo"
                    >
                      <a
                        :href="
                          '/util/get-arquivo-pdf/name/' + anexo.nome_arquivo
                        "
                        target="_blank"
                      >{{ anexo.campo }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </accordion-component>
    </fieldset>
    <div class="row mt-2">
      <div class="col-sm-2">
        <input
          type="button"
          value="Pesquisar"
          name="Pesquisar"
          onclick="cadastro.pesquisar();"
          class="ui-button"
        />
      </div>
      <div class="col-sm-10">
        <div class="text text-right">
          <a
            v-if="bloco.link_boleto && bloco.boleto_pago == 0"
            :href="bloco.link_boleto"
            class="btn"
            target="_blank"
          >Imprimir Boleto</a
          >
          <a
            :href="`/gtiv/gtiv-bloco/documents/cod_bloco/${bloco.cod_gtiv_bloco}?impressao=true`"
            class="btn"
            v-if="bloco.cod_gtiv_bloco || imprimir"
            target="_blank"
          >Imprimir {{ bloco.is_manual_generated ? "Bloco" : "GTIV" }}</a
          >
          <input
            type="submit"
            value="Salvar"
            name="Salvar"
            class="btn"
            @click="onSaveClick"
            v-if="!bloco.cod_gtiv_bloco || bloco.is_manual_generated"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    blocoModel: {
      required: false,
    },
    culturasPermitidas: {
      required: true,
    },
    statuses: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    imprimir: false,
    active: null,
    mask: "AAA-####",
    // is_mercosul: null,
    is_produtor_sidagro: false,
    selected_propriedade: false,
    variedade_cod: null,
    variedade: "",
    bloco: {
      qtd: 1,
      preenchimentoEletronico: true,
      fichas: [
        {
          anexos: [],
          cod_gtiv_bloco: null,
          cod_gtiv_ficha: null,
          cod_municipio_destino: null,
          cod_status: 23,
          cpf_cnpj_destinatario: null,
          cpf_condutor: null,
          destinatario: null,
          endereco_destino: null,
          identificacao: "-",
          inscricao_estadual_destino: null,
          is_mercosul: false,
          itinerario: null,
          marca_modelo_veiculo: null,
          mask: "AAA-####",
          municipio_destino: null,
          municipio_veiculo: null,
          municipio_veiculoObj: {
            label: null,
            value: null,
            uf: null,
          },
          nacionalidade_veiculo: null,
          nacionalidade_veiculoObj: {
            label: null,
            value: null,
          },
          nome_condutor: null,
          num_habilitacao: null,
          placa_veiculo: null,
          prestou_conta: false,
          produtos: [],
          tipo_transporte: null,
          tipo_transporte_outro: null,
          uf_destino: null,
          validade: null,
          municipioDestinoObj: {
            label: null,
            value: null,
            uf: null,
          },
        },
      ]
    },
    selectedProduto: "",
    propriedades: [],
    moment: moment,
    unidadesDeMedida: [],
    unidadesProducao: [],
    culturasPermitidasPropriedade: [],
  }),
  computed: {
    getUnidadesProducao() {
      return this.unidadesProducao.filter(
        (up) => up.cd_cultura.toString() == this.selectedProduto.toString()
      );
    },
  },
  methods: {
    getStatusName(codStatus) {
      const status = {
        9: "Pendente",
        23: "Prestado",
        24: "Pendente de informações",
        22: "Extraviado",
        26: "Extraviado 2ª VIA",
      };

      return status[parseInt(codStatus)];
    },
    addProdutos(arrayProdutos, indexProduto) {
      this.bloco.fichas[indexProduto].produtos = arrayProdutos;
      this.selectedProduto = "";
    },
    selectFichaMask(el) {
      return el.mask || "AAA-####";
    },
    isRequired(ficha) {
      if (this.bloco.preenchimentoEletronico) return true;
      return ficha.cod_status == 23;
    },
    onCpfCnpjBlur() {
      const cpfCnpj =
        this.bloco.cpf_cnpj_produtor_origem &&
        this.bloco.cpf_cnpj_produtor_origem.replace(/[^0-9]/g, "");
      if (!cpfCnpj || cpfCnpj == "") {
        return;
      } else if (
        (cpfCnpj.length !== 11 && cpfCnpj.length !== 14) ||
        (cpfCnpj.length === 11 && !window.cpfValidation(cpfCnpj)) ||
        (cpfCnpj.length === 14 && !window.cnpjValidation(cpfCnpj))
      ) {
        this.bloco.cpf_cnpj_produtor_origem = "";
        this.$toast.error("CPF/CNPJ inválido.");
        return;
      }

      this.is_produtor_sidagro = false;
      this.propriedades = [];

      window.showPageLoading();

      window.api
        .fetch(`/sidagro-api/get-produtor-and-propriedades`, {
          params: {
            cpf_cnpj: cpfCnpj,
          },
        })
        .then((response) => {
          const produtor = response.data;
          this.is_produtor_sidagro = true;

          this.bloco = {
            ...this.bloco,
            nome_produtor_origem: produtor.nomeprodutor,
            tipo_produtor: produtor.tipoprodutor,
          };
          let propriedades = produtor.propriedades || [];

          this.propriedades = propriedades.filter(
            (item) => item.qtd_unidades_producao != 0
          );
          window.hidePageLoading();
        })
        .catch((error) => {
          this.bloco.cpf_cnpj_produtor_origem = "";
          window.hidePageLoading();
        });
    },
    onCpfCnpjDestinoBlur(ficha) {
      const cpfCnpj =
        ficha.cpf_cnpj_destinatario &&
        ficha.cpf_cnpj_destinatario.replace(/[^0-9]/g, "");
      if (!cpfCnpj || cpfCnpj == "") {
        return;
      } else if (
        (cpfCnpj.length !== 11 && cpfCnpj.length !== 14) ||
        (cpfCnpj.length === 11 && !window.cpfValidation(cpfCnpj)) ||
        (cpfCnpj.length === 14 && !window.cnpjValidation(cpfCnpj))
      ) {
        ficha.cpf_cnpj_destinatario = "";
        this.$toast.error("CPF/CNPJ inválido.");
        return;
      }

      window.showPageLoading();

      window.api
        .fetch(`/api/get-pessoa-data`, {
          params: {
            cpf_cnpj: cpfCnpj,
          },
        })
        .then((response) => {
          const pessoa = response.data;

          if (pessoa.nome || pessoa.razao_social) {
            ficha.destinatario = pessoa.nome || pessoa.razao_social;
          }

          if (pessoa.logradouro) {
            ficha.endereco_destino =
              pessoa.logradouro +
              (pessoa.logradouro_numero ? ", " + pessoa.logradouro_numero : "");
          }

          if (pessoa.inscricao_estadual) {
            ficha.inscricao_estadual_destino = pessoa.inscricao_estadual;
          }

          if (pessoa.municipio) {
            ficha.municipioDestinoObj = {
              label: null,
              value: pessoa.municipio,
              uf: null,
            };
          }

          window.hidePageLoading();
        })
        .catch((error) => {
          window.hidePageLoading();
        });
    },
    onSaveClick() {
      const formValid = window.validateForm(this.$el);

      if (!formValid) return;

      const formData = new FormData();
      formData.set("data", JSON.stringify(this.bloco));

      document
        .querySelectorAll(".anexo-ficha-input-file")
        .forEach((inputFile) => {
          formData.append(inputFile.name, inputFile.files[0]);
        });

      window.showPageLoading();

      window.api
        .fetch("/gtiv/gtiv-bloco/salvar", {
          method: "post",
          data: formData,
          headers: {"Content-Type": "multipart/form-data"},
        })
        .then((response) => {
          window.hidePageLoading();
          this.$toast.success(response.message);
          this.imprimir = true;
          this.loadSavedData(response.data);
        })
        .catch(() => {
          window.hidePageLoading();
        });
    },
    onChangePropriedade(ev) {
      const value = ev.target.value;
      const Strings = {};
      Strings.orEmpty = function (entity) {
        return entity || "";
      };
      if (value) {
        this.bloco.nome_propriedade =
          ev.target.options[ev.target.selectedIndex].text;

        // Setar selected_propriedade
        this.selected_propriedade = true;
        let tempEndereco = this.propriedades[ev.target.selectedIndex - 1].aux;
        this.bloco = {
          ...this.bloco,
          endereco_origem:
            Strings.orEmpty(tempEndereco.nm_logradouro) +
            ", " +
            Strings.orEmpty(tempEndereco.nr_endereco) +
            " - " +
            Strings.orEmpty(tempEndereco.nm_bairro),
          municipio_origem: tempEndereco.ds_municipio,
          cod_municipio_origem: tempEndereco.cd_municipio,
          uf_origem: tempEndereco.cd_estado,
        };
      } else {
        this.selected_propriedade = false;
        this.bloco.nome_propriedade = "";
        this.bloco.endereco_origem = "";
        this.bloco.municipio_origem = "";
        this.bloco.uf_origem = "";
      }

      this.loadUnidadesProducao();
    },
    onChangeMunicipioVeiculo(ficha) {
      ficha.municipio_veiculo = ficha.municipio_veiculoObj.label; //label?
    },
    onChangeNacionalidadeVeiculo(ficha) {
      ficha.nacionalidade_veiculo = ficha.nacionalidade_veiculoObj.label; //label?
    },
    onChangeMunicipioDestino(ficha) {
      ficha.cod_municipio_destino = ficha.municipioDestinoObj.value;
      ficha.municipio_destino = ficha.municipioDestinoObj.label;
      ficha.uf_destino = ficha.municipioDestinoObj.uf;
    },
    onChangeUnidadeProducao(val) {
      let name = this.unidadesProducao.find(
        (el) => el.cd_unidade_producao == val
      );
      if (val != "" && typeof name !== "undefined") {
        this.variedade = name.nm_variedade;
      }
    },
    loadSavedData(savedData) {
      savedData.fichas = savedData.fichas.map((ficha) => {
        ficha.municipioDestinoObj = {
          label: ficha.municipio_destino,
          value: ficha.cod_municipio_destino,
          uf: ficha.uf_destino,
        };
        if (ficha.municipio_veiculo) {
          ficha.municipio_veiculoObj = {
            label: ficha.municipio_veiculo,
            value: ficha.municipio_veiculo,
          };
        }
        if (ficha.nacionalidade_veiculo) {
          ficha.nacionalidade_veiculoObj = {
            label: ficha.nacionalidade_veiculo,
            value: ficha.nacionalidade_veiculo,
          };
        }
        return ficha;
      });
      this.bloco = window.clone(savedData);

      this.propriedades = [
        {
          codpropriedade: this.bloco.cod_propriedade,
          nomepropriedade: this.bloco.nome_propriedade,
        },
      ];

      this.loadUnidadesProducao();

      setTimeout(() => {
        if (this.bloco && !this.bloco.is_manual_generated) {
          const formControls = this.$el
            .querySelectorAll(".form-control")
            .forEach((node) => {
              node.setAttribute("disabled", "disabled");
            });
        }
      }, 750);
    },
    loadUnidadesProducao() {
      const codPropriedade = this.bloco.cod_propriedade;
      const cpfCnpjProdutor = this.bloco.cpf_cnpj_produtor_origem;
      if (!codPropriedade || !cpfCnpjProdutor) {
        this.unidadesProducao = [];
        return;
      }

      this.culturasPermitidasPropriedade = [];

      window.api
        .fetch(`/sidagro-api/get-unidades-producao`, {
          params: {
            cod_propriedade: codPropriedade,
            cpf_cnpj_produtor: cpfCnpjProdutor.replace(/[^\d]+/g, ""),
          },
        })
        .then((response) => {
          const unidadesProducao = response.data;
          if (unidadesProducao == null) {
            this.$toast.info(
              "Não foram encontradas unidades de produção para essa propriedade"
            );
            return;
          }
          this.unidadesProducao = unidadesProducao;

          const culturasPermitidasPropriedade = [];

          unidadesProducao.forEach((up) => {
            // const allowed = this.culturasPermitidas.some(
            //   (cultPerm) => cultPerm.nome_popular_cultura == up.nm_cultura
            // );

            // if (allowed) {
            //   // culturasPermitidasPropriedade.push({
            //   //   cd_cultura: up.cd_cultura,
            //   //   nm_cultura: up.nm_cultura,
            //   // });
            //   //let produtos = [];
            // }

            //console.log("Aqui ...");
            let obj = {
              cd_cultura: up.cd_cultura,
              nm_cultura: up.nm_cultura,
            };

            //produtos.push(obj);

            let achei = false;

            culturasPermitidasPropriedade.forEach((aux, index) => {
              if (aux.cd_cultura.toString() == up.cd_cultura.toString()) {
                achei = true;
              }
            });

            if (!achei) {
              culturasPermitidasPropriedade.push(obj);
            }

            // TODO: Melhorar o código, estou usando forEach para acelerar
            // Pode ter uma solução mais elegante

            // this.unidadesProducao.forEach((produto, index) => {
            //   //console.log("Aqui ....");
            //   let obj = {
            //     cd_cultura: produto.cd_cultura,
            //     nm_cultura: produto.nm_cultura,
            //   };

            //   //produtos.push(obj);

            //   let achei = false;

            //   produtos.forEach((aux, index) => {
            //     if (
            //       aux.cd_cultura.toString() == produto.cd_cultura.toString()
            //     ) {
            //       achei = true;
            //     }
            //   });

            //   if (!achei) {
            //     produtos.push(obj);
            //   }
            // });
          });

          if (culturasPermitidasPropriedade.length > 0) {
            this.culturasPermitidasPropriedade = [
              ...new Set(culturasPermitidasPropriedade),
            ];
          } else {
            this.$toast.info(
              "Nenhuma cultura permitida para essa propriedade."
            );
          }
        })
        .catch((error) => {
          this.$toast.error("Erro ao carregar as unidades de produção");
        });
    },
    loadUnidadesMedida() {
      window.api
        .fetch("/public-api/get-unidades-medida-gtiv")
        .then((response) => {
          this.unidadesDeMedida = response.data;
        });
    },
    onChangeIs_mercosul(ficha) {
      ficha.placa_veiculo = "";
      ficha.municipio_veiculo = "";
      ficha.nacionalidade_veiculo = "";
      if (ficha.is_mercosul) {
        ficha.mask = "AAA-####";
      } else {
        ficha.mask = "AAA#A##";
      }
    },
    onChangePreenchimentoEletronico(ev) {
      const val = ev.target.checked;
      if (val) {
        this.bloco.preenchimentoEletronico = true;
        this.bloco.qtd = 1;
        this.bloco.fichas = [
          {
            anexos: [],
            cod_gtiv_bloco: null,
            cod_gtiv_ficha: null,
            cod_municipio_destino: null,
            cod_status: 23,
            cpf_cnpj_destinatario: null,
            cpf_condutor: null,
            destinatario: null,
            endereco_destino: null,
            identificacao: "-",
            inscricao_estadual_destino: null,
            is_mercosul: false,
            itinerario: null,
            marca_modelo_veiculo: null,
            mask: "AAA-####",
            municipio_destino: null,
            municipio_veiculo: null,
            municipio_veiculoObj: {
              label: null,
              value: null,
              uf: null,
            },
            nacionalidade_veiculo: null,
            nacionalidade_veiculoObj: {
              label: null,
              value: null,
            },
            nome_condutor: null,
            num_habilitacao: null,
            placa_veiculo: null,
            prestou_conta: false,
            produtos: [],
            tipo_transporte: null,
            tipo_transporte_outro: null,
            uf_destino: null,
            validade: null,
            municipioDestinoObj: {
              label: null,
              value: null,
              uf: null,
            },
          },
        ];
      } else {
        this.bloco.fichas = [];
      }
    },
  },
  beforeMount() {
    this.loadUnidadesMedida();
    if (this.blocoModel) {
      this.loadSavedData(this.blocoModel);
    }
  },
};
</script>
<style lang="scss" scoped>
.pull-right {
  float: right;
}

.badge-24 {
  color: #5bc0de;
}

.badge-22 {
  color: #5cb85c;
}

.badge-23 {
  color: #5cb85c;
}

.badge-26 {
  color: #5cb85c;
}

.badge-9 {
  color: #d9534f;
}

.badge {
  font-size: 13px;
  font-weight: 600;
}

.active {
  color: #fff !important;
}

.status-labels {
  width: 100%;
  display: flex;
  justify-content: flex-end;

  label {
    width: 70px;
    font-weight: bold;
    background: #777777;
    color: #fff;
    font-size: 11px;
    margin: 0px 3px;
    padding: 2px;
    border-radius: 5px 5px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.autocomplete {
  margin-top: 5px;
}

.d-none {
  display: none;
}

.div-status {
  float: right;
  margin-top: -2px;

  .radio {
    .label {
      opacity: 0.7;
    }

    input[type="radio"]:checked + .label,
    input[type="radio"] + .label:hover {
      opacity: 1;
    }

    &.status-9 {
      input[type="radio"] + .label {
        border-color: #fc6836;

        &:after {
          background: #fc6836;
        }
      }
    }

    &.status-23 {
      input[type="radio"] + .label {
        border-color: #056f0d;

        &:after {
          background: #056f0d;
        }
      }
    }

    &.status-24 {
      input[type="radio"] + .label {
        border-color: #0088ff;

        &:after {
          background: #0088ff;
        }
      }
    }

    &.status-22 {
      input[type="radio"] + .label {
        border-color: #f12222;

        &:after {
          background: #f12222;
        }
      }
    }
  }
}
</style>
